﻿import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

import { NotificationsService } from 'angular2-notifications';
import { ErrorLogService } from '../service/error-log.service';



@Injectable()
export class ApplicationErrorHandler implements ErrorHandler {

    private lastError: Error;

    constructor(private injector: Injector) { }

    handleError(error: Error) {

        //avoid rethrowing the same error twice
        if (error === this.lastError) return;

        this.lastError = error;

        const flash = this.injector.get(NotificationsService);
        const log = this.injector.get(ErrorLogService);


        flash.error('Oups !', 'Looks like something went wrong !');
        log.error(error);


        // IMPORTANT: Rethrow the error otherwise it gets swallowed
        throw error;
    }

}